import React, { useEffect, useMemo, useState } from "react";
import { Modal,Input,Radio, Button, Space ,Typography,Spin} from "antd";
import "./index.less";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/redux/reducer/store";
import { updateAddOrShowFavouritiesModel,
    updateAuthorCode,
    updateCommonErrorMessage,
    updateCommonSuccessMessage,
    updateCommonWarnMessage,
    updateCurrentTab,
    updateSelectedFavoriteInfo }
    from "@/redux/actions/lightningAction";
import { LightningAddOrShowFavouritiesEnum, LightningSearchTypeEnum, LightningTabsEnum, LigntningFavouritesEnum } from "@/util/cosntants";
import IF from "@/components/IF";
import { isExistsAuthorCode, operateFavorite } from "@/util/http/Lightning";
import { debounce } from "lodash";
import { IFavoriteModel, IGetCountriesTreeResModel } from "@/util/http/Lightning/responseType";
import deleteImg from "@/resource/images/png/lightning/Delete.png";
import leftArrow from "@/resource/images/png/lightning/left-arrow.png";

const { Title } = Typography;
const FavouritiesModal = (props: any) => {

    const dispatch = useDispatch();

    const handleCancel = () => {
        dispatch(updateAddOrShowFavouritiesModel(null));
    };

    /**
     * For Add
     * 1. if no author code, then should show input box to input author code
     * 2. if author code is exist, show input box to input favourities name
     *
     * For Show
     * 1. if no author code, then should show input box to input author code
     *    then check if author code is exist, if exist, then show tooltip for code match, though show code new tootip
     *    then click process button, should get all favourities list
     * 2. if author code is exist, then show all favourities list
     *
     * 3. provide a return button to return input page
     */

    const isShowFavouritiesModal = useSelector((state: RootState) => state.lightningReducer.isShowFavouritiesModal);
    const addOrShowFavouritiesModal = useSelector((state: RootState) => state.lightningReducer.addOrShowFavouritiesModal);
    const authorCode = useSelector((state: RootState) => state.lightningReducer.authorCode);
    const favoritiesOptions = useSelector((state: RootState) => state.lightningReducer.favoritiesOptions);
    const [inputAuthorCode, setInputAuthorCode] = React.useState<string>("");

    const [ifExistAuthorCode, setIfExistAuthorCode] = React.useState<boolean | undefined>(undefined);

    const [favoritiesName, setFavouritiesName] = React.useState<string>("");
    const [allFavoriteList, setAllFavoriteList] = React.useState<IFavoriteModel[]>([]);

    // for show all favourities

    const publicHandleProcess = async()=>{
        if(addOrShowFavouritiesModal === LightningAddOrShowFavouritiesEnum.SHOW && inputAuthorCode) {
            console.log("publicHandleProcess: 开始获取收藏列表");
            localStorage.setItem("authorCode", inputAuthorCode);
            dispatch(updateAuthorCode(inputAuthorCode));

            // 关键修复：使用await等待数据获取完成
            await publicGetAllFavoritiesList(inputAuthorCode);
        }

        // for Add
        if(addOrShowFavouritiesModal === LightningAddOrShowFavouritiesEnum.ADD){
            console.log("1111publicHandleProcess 2 if ");
            if(!authorCode || !favoritiesName) {
                console.log("1111publicHandleProcess 3 if ");
                // mean should add a new favourities
                // handle show favourities, mean should get all Favourities list
                localStorage.setItem("authorCode",inputAuthorCode);
                dispatch(updateAuthorCode(inputAuthorCode));
            }
            else if(authorCode && favoritiesName) {
                console.log("1111publicHandleProcess else if ");
                // mean should add a new favourities
                try {
                    const res = await operateFavorite({
                        operation: LigntningFavouritesEnum.ADD,
                        authorCode: authorCode,
                        name: favoritiesName,
                        options: favoritiesOptions,
                    });
                    dispatch(updateAddOrShowFavouritiesModel(null));
                    dispatch(updateCommonSuccessMessage("Saved to Favorites successfully!"));
                } catch (error) {
                    dispatch(updateCommonWarnMessage("Save failed. The entered name already exists."));
                }
            }
        }

    };

    const publicHandleReturn = ()=>{
        // handle return, mean should return to input author code page
        setInputAuthorCode("");
        setIfExistAuthorCode(undefined);
        setFavouritiesName("");
        dispatch(updateAuthorCode(""));
        localStorage.removeItem("authorCode");
    };

    // 防抖后的函数，假设这个函数在组件或模块中使用
    const publicHandleAuthorCodeInput = debounce(async (value?: string) => {
        setInputAuthorCode(value || "");
        try {
            const res = await isExistsAuthorCode(value);
            setIfExistAuthorCode(res.data);
        } catch (e) {
            console.error("Error checking author code existence:", e);
        }
    }, 30);

    const publicHandleInput = (value?: string)=>{
        if(addOrShowFavouritiesModal === LightningAddOrShowFavouritiesEnum.ADD) {
            setFavouritiesName(value || "");
        }
        else if(addOrShowFavouritiesModal === LightningAddOrShowFavouritiesEnum.SHOW) {
            // handle show favourities, mean should get all Favourities list
            dispatch(updateAuthorCode(value || ""));
        }
    };

    const [isLoading, setIsLoading] = useState(false);
    const publicGetAllFavoritiesList = async (authorCode: string) => {
        setIsLoading(true);
        try{
            const res = await operateFavorite({
                operation: LigntningFavouritesEnum.SEARCH,
                authorCode: authorCode,
            });
            if(res?.data?.length > 0) {
                console.log("before update allFavoriteList:", allFavoriteList);
                setAllFavoriteList(res.data);
                setSearchQuery("");
                console.log("after update allFavoriteList:", res.data);
            } else {
                setAllFavoriteList([]);
                console.log("get empty");
            }
        }
        catch (e) {
            console.error("Error getting all favourities list:", e);
        } finally {
            setIsLoading(false);
        }
    };


    useEffect(()=>{
        if(addOrShowFavouritiesModal === LightningAddOrShowFavouritiesEnum.SHOW ||
            addOrShowFavouritiesModal === LightningAddOrShowFavouritiesEnum.ADD) {
            // get author code
            const tmpAuthorCode = localStorage.getItem("authorCode");
            if(tmpAuthorCode) {
                dispatch(updateAuthorCode(tmpAuthorCode));
                // if is show, the should get all favorites list
                if(addOrShowFavouritiesModal === LightningAddOrShowFavouritiesEnum.SHOW){
                    publicGetAllFavoritiesList(tmpAuthorCode);
                }
            }
        }
        // if author code is exist, then set inputAuthorCode
        if(addOrShowFavouritiesModal !== LightningAddOrShowFavouritiesEnum.SHOW &&
            addOrShowFavouritiesModal !== LightningAddOrShowFavouritiesEnum.ADD){
            setInputAuthorCode("");
            setIfExistAuthorCode(undefined);
            setFavouritiesName("");
        }
    },[addOrShowFavouritiesModal,authorCode]);

    const [selectedId, setSelectedId] = useState<number | null>(null);
    const handleDelete = async(item) => {
        try {
            const res = await operateFavorite({
                operation: LigntningFavouritesEnum.DELETE,
                authorCode: item?.authorCode,
                id: item?.id,
                name: item?.name
            });

            setAllFavoriteList(prev => prev.filter(fav => fav.id !== item.id));

            setSearchQuery("");
            dispatch(updateCommonSuccessMessage("Favorites Name Deleted Successfully!"));
        } catch (error) {
            dispatch(updateCommonWarnMessage("Failed to delete favorite"));
        }
    };

    const [searchQuery, setSearchQuery] = useState("");

    const filteredFavoriteList = useMemo(() => {
        if (!searchQuery.trim()) return allFavoriteList;
        const query = searchQuery.toLowerCase().trim();
        return allFavoriteList.filter(item =>
            item.name.toLowerCase().includes(query)
        );
    }, [allFavoriteList, searchQuery]);

    const handleOpen = () => {
        // 检查是否已选择收藏项
        console.log("selectedId",selectedId);
        if (selectedId === null) {
            dispatch(updateCommonWarnMessage("Please select a favorite first"));
            return;
        }
        const selectedFavorite = allFavoriteList.find(item => item.id === selectedId);
        if (!selectedFavorite) {
            dispatch(updateCommonWarnMessage("Selected favorite not found"));
            return;
        }
        dispatch(updateSelectedFavoriteInfo(selectedFavorite));
        switch (selectedFavorite?.options?.currentTab) {
            case LightningTabsEnum.LOCATION:
                dispatch(updateCurrentTab(LightningTabsEnum.LOCATION));
                break;
            case LightningTabsEnum.Region:
                dispatch(updateCurrentTab(LightningTabsEnum.Region));
                break;
            case LightningTabsEnum.DRAWONMAP:
                dispatch(updateCurrentTab(LightningTabsEnum.DRAWONMAP));
                break;
            default:
                dispatch(updateCurrentTab(LightningTabsEnum.LOCATION));
        }
        handleCancel();
    };
    return (
        <Modal
            // title="Favourities"
            title={
                <div style={{ display: "flex", alignItems: "center" ,gap:"5px"}}>
                    <IF show={!!authorCode && (addOrShowFavouritiesModal === LightningAddOrShowFavouritiesEnum.SHOW ||
                        addOrShowFavouritiesModal === LightningAddOrShowFavouritiesEnum.ADD
                    )}>
                        <div style={{ display: "flex", alignItems: "center",cursor:"pointer"}}
                            onClick={()=>{
                                publicHandleReturn();
                            }}>
                            <img src={leftArrow} />
                        </div>
                    </IF>
                    <Title level={4} style={{ margin: 0 }}>
                       Favourities
                    </Title>
                </div>
            }
            open={addOrShowFavouritiesModal === LightningAddOrShowFavouritiesEnum.SHOW ||
                addOrShowFavouritiesModal === LightningAddOrShowFavouritiesEnum.ADD
            }
            // onOk={handleOk}
            onCancel={handleCancel}
            width={360}
            className="lightning-favourities-modal"
            footer={null}
            getContainer={()=> document.getElementById("lightning-component") as HTMLElement}
        >
            <div className="lightning-favourities-modal-content">
                <div className="lightning-favourities-modal-content-enter">

                    {/* 只有为 show，并且 author 为值时，会是这里 */}
                    <Spin spinning={isLoading}>
                        <IF show={!!authorCode && addOrShowFavouritiesModal === LightningAddOrShowFavouritiesEnum.SHOW}>
                            {/* then show all favorites list */}
                            <div className="favourite-search-container">
                                <Input
                                    type="text"
                                    placeholder="Search"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    className="favourite-search-input"
                                />
                            </div>
                            {/* 根据搜索结果筛选后的收藏列表 */}
                            {filteredFavoriteList.length > 0 ? (
                                <Radio.Group
                                    value={selectedId}
                                    onChange={(e) => setSelectedId(e.target.value)}
                                    style={{ display: "flex", flexDirection: "column" }}
                                >
                                    {filteredFavoriteList.map((item) => (
                                        <div
                                            key={item.id}
                                            className="favourite-list"
                                        >
                                            <Radio value={item.id}>{item.name}</Radio>
                                            <img
                                                src={deleteImg}
                                                alt="Delete"
                                                style={{ marginLeft: "auto", cursor: "pointer"}}
                                                onClick={(e) => {
                                                    e.stopPropagation(); // 防止触发Radio选择
                                                    handleDelete(item);
                                                }}
                                            />
                                        </div>
                                    ))}
                                </Radio.Group>
                            ) : (
                                <div className="lightning-favourities-modal-content-enter-author-code-list">
                                    {searchQuery ? "No relevant favorites found" : "No Favourities Found"}
                                </div>
                            )}
                        </IF>
                    </Spin>

                    {/* 假如 author 有值，且是 Add，则直接进输入名字的 */}
                    <IF show={!!authorCode && addOrShowFavouritiesModal === LightningAddOrShowFavouritiesEnum.ADD}>
                        <div className="lightning-favourities-modal-content-enter-author-code">
                            Enter Favorities Name
                        </div>
                        {/* For add Favorities */}
                        <Input
                            value={favoritiesName}
                            onChange={(e) => {
                                publicHandleInput(e.target.value);
                            }}
                        />
                    </IF>

                    {/* 假如 author 没值 */}
                    <IF show={!authorCode}>
                        <Input
                            value={inputAuthorCode}
                            onChange={(e) => {
                                publicHandleAuthorCodeInput(e.target.value);
                            }}
                            placeholder="Define Username"
                        />
                        <div style={{marginTop: "10px",marginBottom: "10px",color: "green"}}>
                            {
                                ifExistAuthorCode === undefined ? "" :
                                    (ifExistAuthorCode === true ? "Name match" : "Name new")
                            }
                        </div>
                    </IF>

                </div>


                {/* Button */}
                <div>
                    <div className="lightning-favourities-modal-content-button">
                        <IF show={!(!!authorCode && addOrShowFavouritiesModal === LightningAddOrShowFavouritiesEnum.SHOW)
                        }>
                            <div className="lightning-favourities-modal-content-button-item favourities-invoke"
                                onClick={()=>{
                                    publicHandleProcess();
                                }}
                            >
                            Proceed
                            </div>
                        </IF>
                        <IF show={!!authorCode && (addOrShowFavouritiesModal === LightningAddOrShowFavouritiesEnum.SHOW)}>
                            <div className="lightning-favourities-modal-content-button-item favourities-invoke"
                                onClick={()=>{
                                    handleOpen();
                                }}
                            >
                            Open
                            </div>
                        </IF>
                        <div className="lightning-favourities-modal-content-button-item favourities-cancel"
                            onClick={()=>{
                                handleCancel();
                            }}
                        >
                            Cancel
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default FavouritiesModal;